<template>
  <div class="medias-page">
    <!-- Loader overlay -->
    <v-overlay :value="!isLoaded">
      <v-progress-circular
        indeterminate
        size="64"
      />
    </v-overlay>

    <template v-if="isLoaded">
      <div class="window-container">
        <div class="page-container">
          <div class="item-grid">
            <div
              v-for="media in medias"
              :key="media.media_uuid"
              class="media-item"
              @click="goToUpdate(media.uuid)"
            >
              <DrawThumb
                v-if="media.final_image"
                :image="media.final_image"
              />

              <!-- <DrawThumb v-else :sketch="media.croquis" /> -->
              <v-btn
                v-if="isOnline"
                dark
                color="#880e4f"
                small
                fab
                class="delete"
                @click.stop="deleteMedia(media)"
              >
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </div>
          </div>
        </div>
      </div>

      <div class="save-container">
        <v-btn
          class="save"
          @click="
            $router.push({
              name: 'projects-medias-create',
              params: { uuid: projectUuid }
            })
          "
        >
          Nouveau media
        </v-btn>
      </div>
    </template>
  </div>
</template>

<script>
import DrawThumb from "../components/DrawThumb";
import ErrorHandlingMixin from "@/mixins/ErrorHandlingMixin.vue";

const uuid = require("uuid/v4");

export default {
  name: "MediasPage",
  components: {
    DrawThumb
  },
  mixins: [ErrorHandlingMixin],
  props: { projectUuid: { type: String, default: "" } },
  data() {
    return {
      isLoaded: false,

      medias: [],

      isDrawingVisible: false
    };
  },

  mounted() {
    this.getMedias();
  },

  methods: {
    goToUpdate(media_uuid) {
      this.$store.commit("medias/SET_SELECTED_MEDIA", media_uuid);

      this.$router.push({
        name: "projects-medias-update",
        params: { uuid: this.projectUuid }
      });
    },

    // Delete media
    async deleteMedia(media) {
      this.isLoaded = false;
      // Delete from IndexedDB
      await this.$db.medias.delete(media.uuid);

      await this.$store
        .dispatch("medias/deleteMedia", {
          project_uuid: this.projectUuid,
          media_uuid: media.uuid
        })
        .catch(() => {
          return; // Ignore reject
        });

      this.$notify({
        group: "main",
        type: "success",
        title: "Media supprimé",
        duration: 5000
      });

      this.getMedias();
    },

    /**
     * Save media
     */
    async saveMedia(media) {
      // Generate an uuid
      const mediaUuid = uuid();

      let localMedia = {
        media_uuid: mediaUuid,
        project_uuid: this.projectUuid,
        croquis: media.sketch
      };

      console.log(media);

      // Create sketch
      // await this.$store.dispatch("medias/createSketchMedia", {
      //   project_uuid: this.projectUuid,
      //   media_uuid: mediaUuid,
      //   payload: { croquis: media.sketch }
      // });

      await this.$db.medias.add(localMedia);

      // If image, create a media image
      if (media.image) {
        // let data = new FormData();

        // data.append("image", media.imageBlob, "image.png");

        localMedia.imageBlob = media.imageBlob;
        localMedia.image = media.image;

        await this.$db.medias.update(localMedia.uuid, localMedia);

        // await this.$store.dispatch("medias/createImageMedia", {
        //   project_uuid: this.projectUuid,
        //   media_uuid: mediaUuid,
        //   payload: data
        // });
      }

      // Refetch medias
      // this.medias = await this.$store.dispatch(
      //   "medias/getRemoteMedias",
      //   this.projectUuid
      // );

      this.getMedias();

      this.closeDrawing();
    },

    /**
     * Get medias
     */
    async getMedias() {
      this.medias = [];

      this.medias = await this.$db.medias
        .where({
          project_uuid: this.projectUuid
        })
        .reverse()
        .sortBy("created_at");

      this.isLoaded = true;
    },

    /**
     * Close drawing tool
     */
    closeDrawing() {
      this.editedMediaUuid = -1;
      this.editedMedia = this.defaultMedia;
      this.isDrawingVisible = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.medias-page {
  height: 100%;

  .window-container {
    height: calc(100vh - 56px - 60px);
    overflow: auto;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    padding: 55px 45px;
    .page-container {
      width: 100%;
      height: 100%;
      .item-grid {
        overflow-y: auto;
        display: flex;
        flex-wrap: wrap;
        margin: 0 30px;
        max-height: 100%;

        .media-item {
          margin: 15px;
          background-color: rgba(0, 0, 0, 0.06);
          position: relative;
          width: calc(50% - 30px);
          min-height: 295.63px;
          display: flex;
          flex-direction: column;
          img {
            width: 100%;
            max-height: 100%;
            flex: 1;
            object-fit: contain;
          }
          .v-btn {
            color: white;
            background-color: #880e4f !important;
            box-shadow: none;
            text-transform: none;
            &.delete {
              position: absolute;
              bottom: 41px;
              right: 5px;
              z-index: 9999;
            }
            &:not(.delete) {
              width: 100%;
              border-radius: 0;
            }
            &:disabled,
            &[disabled] {
              border: 1px solid #999999;
              background-color: #cccccc;
              color: #666666;
            }
          }
          p {
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            color: #880e4f;
            padding: 5px;
            // text-overflow: ellipsis;
            overflow: hidden;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
          }
        }
      }
    }
  }
}
</style>
